var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.30315 5.91725L2.58407 7.63633C1.94204 8.27835 1.57283 9.15193 1.57958 10.07C1.58633 10.9881 1.94746 11.867 2.61995 12.5188C3.27164 13.1913 4.15073 13.5524 5.06868 13.5591C6.00757 13.566 6.86047 13.2176 7.50254 12.5756L9.22161 10.8565M11.4174 8.70271L13.1365 6.98364C13.7785 6.34161 14.1477 5.46803 14.141 4.54993C14.1342 3.63183 13.7731 2.75293 13.1006 2.1012C12.4491 1.44967 11.5701 1.08852 10.652 1.08177C9.73392 1.07503 8.86023 1.42328 8.21817 2.06532L6.49909 3.7844M5.2534 9.87088L10.4106 4.71365",
    stroke: "white",
    strokeWidth: 1.26801,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLinkIcon);
export default __webpack_public_path__ + "static/media/AddLinkIcon.a5247eafdc851c67d143f8d0260522a8.svg";
export { ForwardRef as ReactComponent };